import useViewport from '@shared/innmaxLib/hooks/useViewport'
import Desktop from './Desktop'
import Mobile from './Mobile'

const IntenalPage = () => {
  const { isMobile } = useViewport()

  if (isMobile) {
    return <Mobile />
  } else {
    return <Desktop />
  }
}

export default IntenalPage
